import { render, staticRenderFns } from "./UserTypeBadge.vue?vue&type=template&id=4596ef97&"
import script from "./UserTypeBadge.vue?vue&type=script&lang=js&"
export * from "./UserTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports